import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../store";
import { post } from "../../../services/API/ApiClient";
import { DefaultNewCompletedRequestBodyType } from "../../../constant/document";
import { autoRefreshFrequency } from "../../../constant/constant";

export const fetchNewCompletedAudios = createAsyncThunk<any, any, { state: RootState }>("transcribe/fetchNewCompletedAudios", async (args, { getState, dispatch, rejectWithValue }) => {
  try {
    const reqBody = {
      ...getState().NewCompletedAudiosState.currentRequestBody,
      ...getState().TranscribeState.filterValues,
      Keyword: getState().TranscribeState.searchKeyword,
      StatusId: 3,
    };
    dispatch(updateNewCompletedRequestBody(reqBody));

    const response = await post("/packs/search", "Transcribe", reqBody);
    return response.data.results;
  } catch (e) {
    return rejectWithValue(e);
  }
});

export const fetchPaginateNewCompletedAudios = createAsyncThunk<any, any, { state: RootState }>("transcribe/fetchPaginateNewCompletedAudios", async (args, { getState, dispatch, rejectWithValue }) => {
  try {
    const reqBody = {
      ...getState().NewCompletedAudiosState.currentRequestBody,
      PageNum: getState().NewCompletedAudiosState.pagination.page,
    };
    const response = await post("/packs/search", "Transcribe", reqBody);

    return {
      data: response.data.results,

      hasMore: response.data.results.length > 0,
    };
  } catch (e) {
    return rejectWithValue(e);
  }
});

//Fetching the RefreshNewCompleted

export const fetchRefreshNewCompleted = createAsyncThunk<any, any, { state: RootState }>("transcribe/fetchRefreshNewCompletedTenants", async (args, { getState, dispatch, rejectWithValue }) => {
  const currentDataLength = getState().NewCompletedAudiosState.data.length === 0 ? 30 : getState().NewCompletedAudiosState.data.length;
  try {
    const reqBody = {
      ...getState().NewCompletedAudiosState.currentRequestBody,
      pageSize: Math.ceil(currentDataLength / 30) * 30,
    };

    const response = await post("/packs/search", "Transcribe", reqBody);
    return response.data.results;
  } catch (e) {
    return rejectWithValue(e);
  }
});

//Auto Refreshing the NewCompleted Audios
export const autoRefreshNewCompletedAudios = createAsyncThunk<any, any, { state: RootState }>("transcribe/autoRefreshNewCompletedAudios", async (args, { getState, dispatch, rejectWithValue }) => {
  if (getState().NewCompletedAudiosState.autoRefreshNewCompletedState.currentIntervalId) {
    clearInterval(getState().NewCompletedAudiosState.autoRefreshNewCompletedState.currentIntervalId);
  }
  if (getState().NewCompletedAudiosState.autoRefreshNewCompletedState.autoRefresh) {
    const intervalId = setInterval(() => {
      dispatch(fetchRefreshNewCompleted({}));
    }, autoRefreshFrequency);
    dispatch(setNewCompletedAutoRefresh({ intervalId }));
  }
});

//Search NewCompletedAudios
export const searchNewCompletedAudios = createAsyncThunk<any, { searchKeyword: string }, { state: RootState }>("transcribe/searchNewCompletedAudios", async (args, { getState, dispatch }) => {
  dispatch(resetNewCompletedTable());
  dispatch(updateNewCompletedRequestBody({ ...getState().NewCompletedAudiosState.currentRequestBody, Keyword: getState().TranscribeState.searchKeyword }));
  dispatch(fetchNewCompletedAudios({}));
});

//Start the generic action for Tenants
export const resetNewCompletedTable = createAction("transcribe/resetNewCompletedTable");
export const updateNewCompletedRequestBody = createAction<DefaultNewCompletedRequestBodyType>("transcribe/updateNewCompletedRequestBody");
export const stopNewCompletedAutoRefresh = createAction("transcribe/stopNewCompletedAutoRefresh");
export const setNewCompletedAutoRefresh = createAction<{ intervalId: NodeJS.Timer }>("transcribe/setNewCompletedAutoRefresh");
export const switchNewCompletedAutoFresh = createAction<{ autoRefresh: boolean }>("transcribe/switchNewCompletedAutoFresh");
//End the generic action for Tenants

//THE STATIC METHOD OF FILTERING

//FilterNewCompletedAudiosTeanants
export const filterNewCompletedAudiosTenants = createAsyncThunk<any, { filterTenant: string }, { state: RootState }>("transcribe/searchNewCompletedAudios", async (args, { getState, dispatch }) => {
  const tenantMapping: Record<string, number> = {
    "Ernest Young": 3,
    "Williams Lea": 4,
    "Wright Hassall": 2,
    Tenant234: 7,
    Organization: 0,
  };

  // Get the corresponding Tenant ID from the mapping
  const tenantId = tenantMapping[args.filterTenant];
  // console.log(tenantId)

  // if (!tenantId) {
  //   console.error("Tenant ID not found for:", args.filterTenant);
  //   return;
  // }

  // Dispatch actions with the correct TenantId
  dispatch(resetNewCompletedTable());
  dispatch(
    updateNewCompletedRequestBody({
      ...getState().NewCompletedAudiosState.currentRequestBody,
      TenantId: tenantId,
    })
  );
  dispatch(fetchNewCompletedAudios({}));
});
